<template>
  <v-list-item class="conf-list-item">
    <v-list-item-avatar :color="avatarColor">
      <v-icon dark>mdi-account-group</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        {{ conf.name }} &lt;{{ conf.exten }}&gt;
      </v-list-item-title>
      <v-list-item-subtitle class="caption">
        <v-icon small>mdi-account-switch</v-icon>
        {{ $t('confr.capacity') }}: {{ conf.maxusers }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="caption conf-list-member">
        <v-icon small>mdi-account-multiple-check</v-icon>
        {{ $t('confr.members') }}: {{ memNum }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom light>
        <template v-slot:activator="{ on }">
          <v-btn class="watch-btn" icon small v-on="on" @click="toggleWatch">
            <v-icon small :color="confWatched ? 'green' : 'grey lighten-2'">
              mdi-eye{{ confWatched ? '' : '-off' }}
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $t('confr.tooltip.watch') }}
        </span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import events from 'Store/events'

export default {
  name: 'conference-list-item',
  props: {
    conf: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      isConferenceWatched: 'conferences/isConferenceWatched'
    }),
    avatarColor: function () {
      return this.memNum > 0
        ? 'green'
        : 'primary'
    },
    memNum: function () {
      return this.conf.members?.length ?? 0
    },
    confWatched: function () {
      return this.isConferenceWatched(this.conf)
    }
  },
  methods: {
    ...mapActions({
      watchToggle: 'conferences/toggleWatch'
    }),
    toggleWatch: function () {
      this.watchToggle({ conference: this.conf, watch: !this.confWatched }).catch(err => {
        this.dbg(err)
        events.pubError('Failed to update conference watch value.')
      })
    }
  }
}
</script>

<style scoped>
</style>
